import SimilarRestaurants from "./SimilarRestaurants";

export default SimilarRestaurants;
